<ng-template #noData>
    <span class="common-gray">{{ 'shared.notFilledIn' | translate }}</span>
</ng-template>
<ng-template #noData99>
    <span class="common-gray">{{ 'shared.notFilledIn' | translate }} (99)</span>
</ng-template>

<!-- Modal Trigger Button -->
<a (click)="showContactDialog()" class="text-link" data-toggle="modal"
    ><u>{{ 'directory.pages.userProfile.contactDetails' | translate }}</u></a
>

<!-- Modal -->
<p-dialog
    header="{{ 'directory.pages.userProfile.contactDetails' | translate }}"
    [modal]="true"
    [(visible)]="showContact"
    [style]="{ width: '25rem' }"
    appendTo="body"
>
    <!-- City -->
    <div>
        <span class="place-icon mr-2" title="{{ 'directory.pages.userProfile.city' | translate }}">
            <em class="icon icon-marker fw-b"></em>
        </span>
        <span class="common-gray" *ngIf="!!user?.city && user?.city !== 'undefined'; else noData">{{ user.city }}</span>
    </div>

    <!-- Geographical Area -->
    <div>
        <span class="place-icon mr-2" title="{{ 'filters.shared.locationFilters' | translate }}">
            <em class="icon icon-world fw-b"></em>
        </span>
        <span
            class="common-gray"
            *ngIf="!!user.geographicalArea?.id && user.geographicalArea.id !== '99'; else noData99"
            >{{ user.geographicalArea?.name }} ({{ user.geographicalArea?.id }})</span
        >
    </div>

    <!-- Email -->
    <div *ngIf="showEmail">
        <span class="place-icon mr-2" title="Email">
            <em class="icon-contact"></em>
        </span>
        <span *ngIf="!!user.email; else noData">
            <a href="mailto:{{ user.email }}" class="m-auto mailto-link">{{ user.email }}</a>
        </span>
    </div>

    <!-- Office Phone -->
    <div>
        <span class="place-icon mr-2" title="{{ 'directory.pages.userProfile.phone' | translate }}">
            <em class="icon icon-telephone"></em>
        </span>
        <span class="common-gray" *ngIf="!!user.officePhone; else noData">{{ user.officePhone }}</span>
    </div>

    <!-- Mobile Phone -->
    <div>
        <span class="place-icon mr-2" title="{{ 'directory.pages.userProfile.mobile' | translate }}">
            <em class="icon icon-mobile"></em>
        </span>
        <span class="common-gray" *ngIf="!!user.mobilePhone; else noData">{{ user.mobilePhone }}</span>
    </div>

    <!-- LinkedIn -->
    <div>
        <span class="place-icon mr-2" title="{{ 'directory.pages.userProfile.linkedIn' | translate }}">
            <em class="icon icon-linkedin"></em>
        </span>
        <span class="text-link" *ngIf="user.linkedIn; else noData">
            <a href="{{ user.linkedIn }}" target="_blank" class="m-auto">{{
                'directory.pages.userProfile.linkedIn' | translate
            }}</a>
        </span>
    </div>

    <p-footer>
        <button type="button" class="btn btn-secondary" (click)="showContact = false" data-dismiss="modal">
            {{ 'components.button.buttonClose' | translate }}
        </button>
    </p-footer>
</p-dialog>
